import React from "react";
import {Call, Message} from "../../assets/icons";
import SectionParagraph from "../SectionParagraph";
import {useLanguage} from "../../hooks/LanguageContext"; // Import the language hook

const FooterContactUsInfoBox = ({ data }) => {
	const { direction } = useLanguage(); // Get the language direction (LTR or RTL)

	return (
		<section className="md:w-[471px] w-full flex flex-col items-start gap-[25px]">
			{data.id && (
				<h4
					className={`headline-4-ar text-grayscale-700 ${direction === "rtl" ? "text-right" : "text-left"}`}
				>
					{direction === "ltr" ? "Contact Us" : "تواصل معنا"}
				</h4>
			)}

			<ul className="w-full flex flex-col items-start gap-[25px]">
				{/* Check if data contains each key and render if it exists */}
				{data.phone && (
					<li className="flex items-center md:whitespace-nowrap justify-start gap-2">
						<Call />
						<SectionParagraph align={"items-start"} paragraph={data.phone} />
					</li>
				)}
				{data.sales_email && (
					<li className="flex items-center md:whitespace-nowrap justify-start gap-2">
						<Message />
						<SectionParagraph align={"items-start"} paragraph={data.sales_email} />
					</li>
				)}
				{data.marketing_email && (
					<li className="flex items-center md:whitespace-nowrap justify-start gap-2">
						<Message />
						<SectionParagraph align={"items-start"} paragraph={data.marketing_email} />
					</li>
				)}
				{data.cs_email && (
					<li className="flex items-center md:whitespace-nowrap justify-start gap-2">
						<Message />
						<SectionParagraph align={"items-start"} paragraph={data.cs_email} />
					</li>
				)}
			</ul>
		</section>
	);
};

export default FooterContactUsInfoBox;
